<template>
  <div 
    v-if="nodes !== undefined && nodes.length"
    class="nodes-list">
    <nav>
      <ul>
        <li 
        v-for="(node, index) of nodes"
        :key="index">
          <router-link 
            v-if="node.sys.contentType.sys.id === 'nodes'"
            :to="{ name: 'single-category', params: { slug: node.fields.category.fields.slug } }"
            class="underline_link">
              {{ node.fields.category.fields.title }}
          </router-link>
          <router-link 
            v-else-if="node.sys.contentType.sys.id === 'tags'"
            :to="{ name: 'single-tag', params: { slug: node.fields.slug } }"
            class="underline_link">
              {{ node.fields.title }}
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NodesList',
  props: {
    nodes: {
      type: Array,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
  @import './../../assets/scss/breakpoint.scss';
  @import './../../assets/scss/typo.scss';
  .nodes-list{
    display: block;
    left: -18px; width: calc(100% + 36px);
    
    @include media(">=large"){
      display: none;
    }
    ul, li{
      list-style: none;
      list-style-type: none;
      padding: 0;
    }
    ul{
      flex-direction: row;
      overflow: scroll;
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      padding: 20px 0 20px 18px;

      li{
        display: inline-block;
        margin-right: 25px;
      }
      a{
        font-family: 'Circular Std', sans-serif;
        font-weight: 900;
        color: #222222; text-decoration: none;
        font-size: 18px; line-height: 1.2; letter-spacing: .2px;
      }
    }
  }
</style>
